import { render, staticRenderFns } from "./AICartoon_Price.vue?vue&type=template&id=2cd196b2&scoped=true"
import script from "./AICartoon_Price.vue?vue&type=script&lang=js"
export * from "./AICartoon_Price.vue?vue&type=script&lang=js"
import style0 from "./AICartoon_Price.vue?vue&type=style&index=0&id=2cd196b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd196b2",
  null
  
)

export default component.exports